module.exports = __webpack_public_path__ + "static/1.2_Clipboard_Icon-9fc355339e737e7c9bf639566d791197.svg";